<template>
  <div class="warp">
    <!-- <p class="MsoNormal" align="left" style="text-align: left; line-height: 20pt; layout-grid-mode: char"></p> -->
    <!-- <p style="font-family: 宋体;font-size: 16px;">
      机构名称: <span>{{ info.oname }}</span>
    </p> -->
    <p style="font-family: 宋体;font-size: 16px;margin-bottom: 12px;">
      联系地址: <span>{{ info.address || '暂无' }}</span>
    </p>
    <p style="font-family: 宋体;font-size: 16px;">
      联系电话: <span>{{ info.phone || '暂无' }}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {}
  },
  computed: {
    info: function() {
      return this.$store.getters.getInfo(['oname', 'address', 'phone'])
    }
  }
}
</script>
<style lang="less" scoped>
.warp {
  font-size: 16px;
  color: #181D21;
}
</style>
